import { render, staticRenderFns } from "./GetReviews.vue?vue&type=template&id=ff3af236&"
import script from "./GetReviews.vue?vue&type=script&lang=js&"
export * from "./GetReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports